// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Forms feature (library, builder, settings, automations, submissions, public + portal). */

.fm-page,
.fm-public,
.fm-portal,
.modal-panel {
  --fm-blue: #1463ff;
  --fm-blue-hover: #0b52e6;
  --fm-blue-soft: #eef4ff;
  --fm-ink: #0f172a;
  --fm-muted: #64748b;
  --fm-line: #e6eaf2;
  --fm-line-strong: #d7deea;
  --fm-bg-soft: #f7f9fc;
  --fm-radius: 14px;
  --fm-shadow: 0 1px 2px rgb(15 23 42 / 4%), 0 4px 14px rgb(15 23 42 / 4%);
}

.fm-page {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  color: var(--fm-ink);
}

.fm-card {
  background: #fff;
  border: 1px solid var(--fm-line);
  border-radius: var(--fm-radius);
  box-shadow: var(--fm-shadow);
}

/* ---------- Buttons ---------- */

.fm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.55rem 1rem;
  border-radius: 10px;
  border: 1px solid var(--fm-line-strong);
  background: #fff;
  color: var(--fm-ink);
  font: inherit;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s, color 0.15s, box-shadow 0.15s;
}

.fm-btn:hover:not(:disabled) {
  border-color: #b9c5da;
  background: var(--fm-bg-soft);
}

.fm-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.fm-btn--blue {
  background: var(--fm-blue);
  border-color: var(--fm-blue);
  color: #fff;
  box-shadow: 0 2px 6px rgb(20 99 255 / 25%);
}

.fm-btn--blue:hover:not(:disabled) {
  background: var(--fm-blue-hover);
  border-color: var(--fm-blue-hover);
  color: #fff;
}

.fm-btn--outline-blue {
  border-color: #b8cdfb;
  color: var(--fm-blue);
}

.fm-btn--outline-blue:hover:not(:disabled) {
  background: var(--fm-blue-soft);
  border-color: var(--fm-blue);
}

.fm-btn--outline-danger {
  border-color: #f5b5b5;
  color: #dc2626;
}

.fm-btn--outline-danger:hover:not(:disabled) {
  background: #fef2f2;
  border-color: #ef4444;
}

.fm-btn--danger-solid {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
}

.fm-btn--danger-solid:hover:not(:disabled) {
  background: #b91c1c;
  border-color: #b91c1c;
}

.fm-btn--ghost {
  border-color: transparent;
  background: transparent;
  color: var(--fm-blue);
  padding-left: 0.2rem;
}

.fm-btn--lg {
  padding: 0.75rem 1.35rem;
  font-size: 0.95rem;
}

.fm-btn--wide {
  min-width: 5.5rem;
}

.fm-btn--sm {
  padding: 0.38rem 0.7rem;
  font-size: 0.8rem;
  border-radius: 8px;
}

.fm-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  color: #475569;
  cursor: pointer;
  padding: 0;
}

.fm-icon-btn:hover:not(:disabled),
.fm-icon-btn.is-open {
  background: #f1f4f9;
  color: var(--fm-ink);
}

.fm-icon-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.fm-icon-btn.is-danger:hover:not(:disabled) {
  background: #fef2f2;
  color: #dc2626;
}

.fm-link-btn {
  background: none;
  border: 0;
  color: var(--fm-blue);
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.fm-flip {
  transform: rotate(180deg);
}

/* ---------- Alerts / misc ---------- */

.fm-alert {
  margin: 0;
  padding: 0.65rem 0.9rem;
  border-radius: 10px;
  font-size: 0.86rem;
  font-weight: 500;
}

.fm-alert--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.fm-alert--ok {
  background: #ecfdf3;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.fm-alert--warn {
  background: #fff8eb;
  color: #9a5b00;
  border: 1px solid #fde3b0;
}

.fm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2.5rem 1rem;
  color: var(--fm-muted);
  text-align: center;
  margin: 0;
}

.fm-empty p {
  margin: 0;
}

.fm-hint {
  display: block;
  margin: 0;
  color: var(--fm-muted);
  font-size: 0.78rem;
  line-height: 1.45;
}

.fm-hint.is-warn {
  color: #b45309;
}

.fm-back {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: #475569;
  font-size: 0.88rem;
  font-weight: 500;
  width: fit-content;
}

.fm-back:hover {
  color: var(--fm-blue);
  text-decoration: none;
}

.fm-eyebrow {
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--fm-muted);
}

/* ---------- Library ---------- */

.fm-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.fm-page-head h1,
.fm-editor-title h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--fm-ink);
}

.fm-page-head p,
.fm-editor-title p {
  margin: 0.3rem 0 0;
  color: var(--fm-muted);
  font-size: 0.92rem;
}

.fm-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.fm-stat {
  display: flex;
  align-items: center;
  gap: 0.95rem;
  padding: 1.15rem 1.2rem;
  background: #fff;
  border: 1px solid var(--fm-line);
  border-radius: var(--fm-radius);
  box-shadow: var(--fm-shadow);
  text-align: left;
  font: inherit;
  color: inherit;
}

.fm-stat.is-clickable {
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}

.fm-stat.is-clickable:hover {
  border-color: #c9d6ee;
  box-shadow: 0 6px 18px rgb(15 23 42 / 8%);
}

.fm-stat.is-active {
  border-color: var(--fm-blue);
  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);
}

.fm-stat-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 12px;
}

.fm-stat-icon--purple {
  background: #f1ecff;
  color: #6d3fd8;
}

.fm-stat-icon--green {
  background: #e7f8ef;
  color: #16a34a;
}

.fm-stat-icon--amber {
  background: #fff3df;
  color: #ea8a0c;
}

.fm-stat-icon--red {
  background: #fdeaea;
  color: #dc2626;
}

.fm-stat-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.fm-stat-text strong {
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1.1;
}

.fm-stat-text > span {
  color: #475569;
  font-size: 0.86rem;
}

.fm-stat-text em {
  font-style: normal;
  font-size: 0.8rem;
  font-weight: 600;
  color: #dc2626;
}

.fm-stat-sub--blue {
  color: var(--fm-blue);
}

.fm-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.fm-toolbar-right {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.fm-chips {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.fm-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.85rem;
  border-radius: 9px;
  border: 1px solid var(--fm-line);
  background: #fff;
  color: #334155;
  font: inherit;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.fm-chip:hover {
  border-color: #c9d6ee;
}

.fm-chip.is-on {
  background: var(--fm-blue);
  border-color: var(--fm-blue);
  color: #fff;
}

.fm-chip--filter {
  background: #fff8eb;
  border-color: #fde3b0;
  color: #9a5b00;
}

.fm-chip-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: #eef2f8;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 700;
}

.fm-chip.is-on .fm-chip-count {
  background: rgb(255 255 255 / 22%);
  color: #fff;
}

.fm-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 12.5rem;
  padding: 0 0.75rem;
  border: 1px solid var(--fm-line);
  border-radius: 10px;
  background: #fff;
  color: #94a3b8;
}

.fm-search:focus-within {
  border-color: var(--fm-blue);
  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);
}

.fm-search input {
  flex: 1;
  border: 0;
  outline: none;
  padding: 0.55rem 0;
  font: inherit;
  font-size: 0.86rem;
  background: transparent;
  color: var(--fm-ink);
  min-width: 0;
}

.fm-sort {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0 0.6rem 0 0.75rem;
  border: 1px solid var(--fm-line);
  border-radius: 10px;
  background: #fff;
  color: var(--fm-muted);
  font-size: 0.84rem;
}

.fm-sort select,
.fm-sort .searchable-select-trigger {
  appearance: none;
  border: 0;
  background-color: transparent;
  background-image: none;
  box-shadow: none;
  font: inherit;
  font-weight: 600;
  color: var(--fm-ink);
  padding: 0.55rem 1.3rem 0.55rem 0;
  cursor: pointer;
  outline: none;
  width: auto;
  min-width: 6rem;
  border-radius: 0;
}

.fm-sort .searchable-select {
  width: auto;
  flex: 1;
  min-width: 0;
}

.fm-sort svg {
  position: absolute;
  right: 0.6rem;
  pointer-events: none;
}

.fm-table-card {
  overflow: visible;
}

.fm-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.88rem;
}

.fm-table th {
  text-align: left;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--fm-muted);
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--fm-line);
  background: #fbfcfe;
  white-space: nowrap;
}

.fm-table th:first-child {
  border-top-left-radius: var(--fm-radius);
}

.fm-table th:last-child {
  border-top-right-radius: var(--fm-radius);
}

.fm-table td {
  padding: 0.8rem 1rem;
  border-bottom: 1px solid #eef1f6;
  vertical-align: middle;
  color: var(--fm-ink);
}

.fm-table tbody tr:last-child td {
  border-bottom: 0;
}

.fm-table tr.is-link {
  cursor: pointer;
}

.fm-table tbody tr.is-link:hover td {
  background: #f8faff;
}

.fm-table tr.is-current td {
  background: var(--fm-blue-soft);
}

.fm-name-cell {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-weight: 600;
}

.fm-page .fm-name-cell a {
  color: var(--fm-ink);
}

.fm-page .fm-name-cell a:hover {
  color: var(--fm-blue);
  text-decoration: none;
}

.fm-new-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.3rem;
  border-radius: 999px;
  background: var(--fm-blue);
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
}

.fm-row-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 8px;
}

.fm-row-icon--website_form {
  background: #e7f8ef;
  color: #16a34a;
}

.fm-row-icon--questionnaire {
  background: #fdeaf6;
  color: #d63c98;
}

.fm-row-icon--client_request {
  background: #f1ecff;
  color: #6d3fd8;
}

.fm-row-icon--template {
  background: #f1ecff;
  color: #8b5cf6;
}

.fm-muted-cell {
  color: #475569 !important;
}

.fm-due {
  font-size: 0.74rem;
  color: var(--fm-muted);
  margin-top: 0.1rem;
}

.fm-due.is-late {
  color: #dc2626;
  font-weight: 600;
}

.fm-actions-cell {
  width: 3rem;
  text-align: right;
}

.fm-check-cell {
  width: 2.75rem;
}

.fm-check-cell input {
  width: 1rem;
  height: 1rem;
  accent-color: var(--fm-blue);
  cursor: pointer;
}

.fm-type {
  display: inline-flex;
  align-items: center;
  padding: 0.22rem 0.6rem;
  border-radius: 7px;
  font-size: 0.76rem;
  font-weight: 600;
  white-space: nowrap;
}

.fm-type--website_form {
  background: #e9f0ff;
  color: #2459d9;
}

.fm-type--questionnaire {
  background: #f1ecff;
  color: #6d3fd8;
}

.fm-type--client_request {
  background: #fdecf6;
  color: #d43d95;
}

.fm-type--template {
  background: #f1f3f7;
  color: #475569;
}

.fm-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.24rem 0.65rem;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 600;
  white-space: nowrap;
}

.fm-status-dot {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: currentColor;
}

.fm-status--green {
  background: #e7f8ef;
  color: #15803d;
}

.fm-status--amber {
  background: #fff3df;
  color: #c2610c;
}

.fm-status--red {
  background: #fdeaea;
  color: #dc2626;
}

.fm-status--gray {
  background: #f1f3f7;
  color: #64748b;
}

.fm-status--slate {
  background: #eef1f6;
  color: #334155;
}

.fm-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--fm-line);
  color: var(--fm-muted);
  font-size: 0.84rem;
}

.fm-pager-btns {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.fm-pager-num {
  min-width: 2rem;
  height: 2rem;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  font: inherit;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
}

.fm-pager-num:hover {
  background: #f1f4f9;
}

.fm-pager-num.is-on {
  background: var(--fm-blue);
  color: #fff;
}

.fm-pager-gap {
  padding: 0 0.25rem;
}

/* ---------- Menu ---------- */

.fm-menu {
  position: relative;
  display: inline-flex;
}

.fm-menu-list {
  position: absolute;
  top: calc(100% + 0.3rem);
  z-index: 40;
  min-width: 13rem;
  padding: 0.35rem;
  background: #fff;
  border: 1px solid var(--fm-line);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgb(15 23 42 / 14%);
  display: flex;
  flex-direction: column;
}

.fm-menu-list--right {
  right: 0;
}

.fm-menu-list--left {
  left: 0;
}

.fm-menu-list button {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.55rem 0.65rem;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font: inherit;
  font-size: 0.86rem;
  color: #1e293b;
  text-align: left;
  cursor: pointer;
}

.fm-menu-list button svg {
  color: #64748b;
}

.fm-menu-list button:hover:not(:disabled) {
  background: #f3f6fb;
}

.fm-menu-list button.is-danger,
.fm-menu-list button.is-danger svg {
  color: #dc2626;
}

.fm-menu-list button.is-danger:hover {
  background: #fef2f2;
}

/* ---------- Form controls (admin) ---------- */

.fm-stack {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.fm-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin: 0;
}

.fm-field > span,
.fm-field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #1e293b;
}

.fm-field > span em {
  font-style: normal;
  font-weight: 400;
  color: var(--fm-muted);
}

.fm-field input:not([type='checkbox']):not([type='radio']),
.fm-field select,
.fm-field .searchable-select-trigger,
.fm-field textarea,
.fm-option-row input,
.fm-rule-name {
  width: 100%;
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--fm-line-strong);
  border-radius: 9px;
  background: #fff;
  font: inherit;
  font-size: 0.87rem;
  color: var(--fm-ink);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.fm-field textarea {
  resize: vertical;
  min-height: 4.5rem;
  line-height: 1.45;
}

.fm-field input:focus,
.fm-field select:focus,
.fm-field .searchable-select-trigger:focus,
.fm-field textarea:focus,
.fm-option-row input:focus,
.fm-rule-name:focus {
  border-color: var(--fm-blue);
  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);
}

.fm-field input:disabled,
.fm-field select:disabled {
  background: #f6f8fb;
  color: #94a3b8;
}

.fm-select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.fm-select-wrap select,
.fm-select-wrap .searchable-select-trigger {
  appearance: none;
  padding-right: 2.2rem !important;
  cursor: pointer;
  background-image: none;
  box-shadow: none;
}

.fm-select-wrap .searchable-select {
  flex: 1;
  min-width: 0;
}

.fm-select-wrap > svg {
  position: absolute;
  right: 0.7rem;
  pointer-events: none;
  color: #64748b;
}

.fm-select-clear select,
.fm-select-clear .searchable-select-trigger {
  padding-right: 3.6rem !important;
}

.fm-clear-btn {
  position: absolute;
  right: 2.1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.4rem;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.fm-clear-btn:hover {
  background: #f1f4f9;
  color: #0f172a;
}

.fm-input-icon {
  position: relative;
  display: flex;
  align-items: center;
}

.fm-input-icon > svg {
  position: absolute;
  left: 0.75rem;
  color: #64748b;
  pointer-events: none;
}

.fm-input-icon input {
  padding-left: 2.35rem !important;
}

.fm-check {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  font-size: 0.84rem;
  color: #1e293b;
  cursor: pointer;
}

.fm-check input {
  margin-top: 0.15rem;
  width: 1rem;
  height: 1rem;
  accent-color: var(--fm-blue);
  flex: 0 0 auto;
}

.fm-check small {
  display: block;
  color: var(--fm-muted);
  font-size: 0.76rem;
}

.fm-check.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.fm-toggle {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.7rem 0;
  cursor: pointer;
}

.fm-toggle-text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.fm-toggle-text strong {
  font-size: 0.87rem;
  font-weight: 600;
}

.fm-toggle-text small {
  color: var(--fm-muted);
  font-size: 0.77rem;
}

.fm-toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.fm-toggle-track {
  position: relative;
  flex: 0 0 auto;
  width: 2.4rem;
  height: 1.35rem;
  border-radius: 999px;
  background: #d5dce8;
  transition: background 0.15s;
}

.fm-toggle-track::after {
  content: '';
  position: absolute;
  top: 0.15rem;
  left: 0.15rem;
  width: 1.05rem;
  height: 1.05rem;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgb(15 23 42 / 25%);
  transition: transform 0.15s;
}

.fm-toggle input:checked + .fm-toggle-track {
  background: var(--fm-blue);
}

.fm-toggle input:checked + .fm-toggle-track::after {
  transform: translateX(1.05rem);
}

.fm-toggle input:focus-visible + .fm-toggle-track {
  box-shadow: 0 0 0 3px rgb(20 99 255 / 25%);
}

.fm-toggle.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.fm-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.fm-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
}

.fm-seg {
  display: inline-flex;
  padding: 0.2rem;
  border-radius: 10px;
  background: #f1f4f9;
  gap: 0.2rem;
  width: fit-content;
  flex-wrap: wrap;
}

.fm-seg button {
  border: 0;
  border-radius: 8px;
  padding: 0.42rem 0.8rem;
  background: transparent;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
}

.fm-seg button.is-on {
  background: #fff;
  color: var(--fm-blue);
  box-shadow: 0 1px 3px rgb(15 23 42 / 10%);
}

.fm-copy {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}

.fm-copy input,
.fm-copy textarea {
  flex: 1;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace !important;
  font-size: 0.78rem !important;
  background: var(--fm-bg-soft) !important;
}

.fm-copy.is-multi {
  flex-direction: column;
  align-items: stretch;
}

.fm-copy.is-multi .fm-btn {
  align-self: flex-end;
}

.fm-type-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.fm-type-option {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--fm-line);
  border-radius: 10px;
  cursor: pointer;
}

.fm-type-option input {
  accent-color: var(--fm-blue);
}

.fm-type-option.is-on {
  border-color: var(--fm-blue);
  background: var(--fm-blue-soft);
}

/* ---------- Editor header / tabs ---------- */

.fm-editor {
  gap: 0.9rem;
}

.fm-editor-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.fm-editor-title {
  min-width: 0;
}

.fm-editor-title-row {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  flex-wrap: wrap;
}

.fm-editor-title h1 {
  font-size: 1.55rem;
}

.fm-unsaved {
  font-size: 0.76rem;
  font-weight: 600;
  color: #b45309;
  background: #fff8eb;
  border-radius: 999px;
  padding: 0.18rem 0.6rem;
}

.fm-editor-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.fm-tabs {
  display: flex;
  gap: 0.25rem;
  border-bottom: 1px solid var(--fm-line);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.fm-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.65rem 1.1rem;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
}

.fm-tab:hover {
  color: var(--fm-ink);
}

.fm-tab.is-on {
  color: var(--fm-blue);
  font-weight: 600;
}

.fm-tab.is-on::after {
  content: '';
  position: absolute;
  left: 0.6rem;
  right: 0.6rem;
  bottom: -1px;
  height: 2px;
  border-radius: 2px;
  background: var(--fm-blue);
}

.fm-tab-badge {
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.3rem;
  border-radius: 999px;
  background: var(--fm-blue);
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ---------- Build tab ---------- */

.fm-build {
  display: grid;
  grid-template-columns: 14rem minmax(0, 1fr) 18.5rem;
  gap: 1rem;
  align-items: start;
}

.fm-palette {
  padding: 1rem 0.85rem;
  position: sticky;
  top: 1rem;
}

.fm-palette h3,
.fm-side h3,
.fm-form-type h3,
.fm-auto-builtins h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.fm-palette > p {
  margin: 0.2rem 0 0.75rem;
  color: var(--fm-muted);
  font-size: 0.78rem;
}

.fm-palette ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.fm-palette button {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.45rem 0.55rem;
  border: 1px solid var(--fm-line);
  border-radius: 9px;
  background: #fff;
  font: inherit;
  font-size: 0.84rem;
  font-weight: 500;
  color: #1e293b;
  cursor: grab;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}

.fm-palette button:hover {
  border-color: #b8cdfb;
  background: #fafcff;
  box-shadow: 0 2px 6px rgb(20 99 255 / 8%);
}

.fm-palette button:active {
  cursor: grabbing;
}

.fm-palette-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 7px;
  background: #f1ecff;
  color: #6d3fd8;
  flex: 0 0 auto;
}

.fm-palette-label {
  flex: 1;
}

.fm-grip {
  color: #a3adbf;
}

.fm-canvas {
  overflow: hidden;
  min-height: 30rem;
  transition: box-shadow 0.15s;
}

.fm-canvas.is-dropping {
  box-shadow: 0 0 0 2px rgb(20 99 255 / 25%), var(--fm-shadow);
}

.fm-canvas-title {
  padding: 1.5rem 1.5rem 0.5rem;
}

.fm-canvas-title h2 {
  margin: 0;
  font-size: 1.3rem;
}

.fm-canvas-title p {
  margin: 0.3rem 0 0;
  color: var(--fm-muted);
}

.fm-canvas-body {
  padding: 1.1rem 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.fm-canvas-field {
  position: relative;
  padding: 0.7rem 0.85rem 0.7rem 1.6rem;
  border: 1px solid transparent;
  border-radius: 11px;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s;
  outline: none;
}

.fm-canvas-field:hover {
  border-color: #dbe4f3;
  background: #fbfcff;
}

.fm-canvas-field:focus-visible {
  border-color: #b8cdfb;
}

.fm-canvas-field.is-selected {
  border-color: var(--fm-blue);
  background: #f8fbff;
  box-shadow: 0 0 0 3px rgb(20 99 255 / 10%);
}

.fm-canvas-field.is-dragging {
  opacity: 0.4;
}

.fm-canvas-grip {
  position: absolute;
  left: 0.35rem;
  top: 50%;
  transform: translateY(-50%);
  color: #b4bdcc;
  opacity: 0;
  cursor: grab;
}

.fm-canvas-field:hover .fm-canvas-grip,
.fm-canvas-field.is-selected .fm-canvas-grip {
  opacity: 1;
}

.fm-canvas-control {
  pointer-events: none;
}

.fm-canvas-control .fm-r-field input:disabled,
.fm-canvas-control .fm-r-field textarea:disabled,
.fm-canvas-control .fm-r-field select:disabled {
  background: #fff;
  color: #94a3b8;
  opacity: 1;
}

.fm-canvas-tools {
  position: absolute;
  top: -0.85rem;
  right: 0.75rem;
  display: flex;
  gap: 0.1rem;
  padding: 0.15rem;
  border-radius: 9px;
  background: #fff;
  border: 1px solid var(--fm-line);
  box-shadow: 0 4px 12px rgb(15 23 42 / 10%);
}

.fm-canvas-tools .fm-icon-btn {
  width: 1.75rem;
  height: 1.75rem;
}

.fm-drop-line {
  height: 3px;
  border-radius: 3px;
  background: var(--fm-blue);
  box-shadow: 0 0 0 3px rgb(20 99 255 / 15%);
  margin: 0.15rem 0;
}

.fm-canvas-end {
  margin-top: 0.4rem;
  padding: 0.9rem;
  border: 1.5px dashed #d3dceb;
  border-radius: 11px;
  color: #94a3b8;
  font-size: 0.82rem;
  text-align: center;
}

.fm-canvas.is-dropping .fm-canvas-end {
  border-color: var(--fm-blue);
  color: var(--fm-blue);
  background: var(--fm-blue-soft);
}

.fm-submit.is-static {
  pointer-events: none;
  margin-top: 0.75rem;
}

.fm-side {
  padding: 1.1rem 1rem;
  position: sticky;
  top: 1rem;
}

.fm-side-body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.fm-side h3 span {
  font-weight: 400;
  color: var(--fm-muted);
}

.fm-side-checks {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding-top: 0.25rem;
}

.fm-side-back {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border: 0;
  background: none;
  padding: 0;
  color: var(--fm-blue);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
}

.fm-inspector-title {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.fm-inspector-actions {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  padding-top: 0.6rem;
  border-top: 1px solid var(--fm-line);
}

.fm-options {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.fm-option-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.fm-option-row input {
  padding: 0.42rem 0.6rem;
}

.fm-option-mark {
  flex: 0 0 auto;
  width: 0.9rem;
  height: 0.9rem;
  border: 1.5px solid #a3adbf;
  border-radius: 4px;
}

.fm-option-mark--radio {
  border-radius: 50%;
}

.fm-option-mark--select {
  border-radius: 2px;
  border-width: 0 0 2px;
  height: 0.5rem;
}

.fm-ext-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.fm-ext {
  padding: 0.22rem 0.45rem;
  border-radius: 6px;
  border: 1px solid var(--fm-line);
  background: #fff;
  font: inherit;
  font-size: 0.7rem;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
}

.fm-ext.is-on {
  border-color: var(--fm-blue);
  background: var(--fm-blue-soft);
  color: var(--fm-blue);
}

/* ---------- Respondent rendering (canvas, preview, public, portal) ---------- */

.fm-banner {
  position: relative;
  padding: 1.75rem 1.6rem;
  color: #fff;
  background:
    radial-gradient(circle at 85% 20%, rgb(99 102 241 / 35%), transparent 45%),
    radial-gradient(circle at 10% 110%, rgb(20 99 255 / 30%), transparent 45%),
    linear-gradient(135deg, #0b1220 0%, #16213b 55%, #1d2b4f 100%);
}

.fm-banner h2 {
  margin: 0;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.fm-banner p {
  margin: 0.45rem 0 0;
  color: rgb(226 232 240 / 88%);
  font-size: 0.9rem;
  max-width: 36rem;
}

.fm-render {
  display: flex;
  flex-direction: column;
}

.fm-render-body {
  display: flex;
  flex-direction: column;
  gap: 1.05rem;
  padding: 1.4rem 1.5rem 1.6rem;
}

.fm-r-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.fm-r-label {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--fm-ink);
  margin: 0;
}

.fm-req {
  color: #ef4444;
  margin-left: 0.2rem;
}

.fm-r-help {
  margin: 0;
  font-size: 0.78rem;
  color: var(--fm-muted);
}

.fm-r-error {
  margin: 0;
  font-size: 0.78rem;
  color: #dc2626;
  font-weight: 500;
}

.fm-r-field input:not([type='checkbox']):not([type='radio']),
.fm-r-field textarea,
.fm-r-field select,
.fm-r-field .searchable-select-trigger {
  width: 100%;
  padding: 0.65rem 0.8rem;
  border: 1px solid var(--fm-line-strong);
  border-radius: 10px;
  background: #fff;
  font: inherit;
  font-size: 0.9rem;
  color: var(--fm-ink);
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.fm-r-field textarea {
  resize: vertical;
  min-height: 5.5rem;
}

.fm-r-field input::placeholder,
.fm-r-field textarea::placeholder {
  color: #a0aabb;
}

.fm-r-field input:focus,
.fm-r-field textarea:focus,
.fm-r-field select:focus {
  border-color: var(--fm-blue);
  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);
}

.fm-r-field.has-error input,
.fm-r-field.has-error textarea,
.fm-r-field.has-error select,
.fm-r-field.has-error .fm-drop {
  border-color: #f87171;
}

.fm-r-heading h3 {
  margin: 0.35rem 0 0;
  font-size: 1.08rem;
  font-weight: 700;
}

.fm-r-heading p {
  margin: 0.2rem 0 0;
  color: var(--fm-muted);
  font-size: 0.85rem;
}

.fm-r-divider {
  border: 0;
  border-top: 1px solid var(--fm-line);
  margin: 0.35rem 0;
  opacity: 1;
}

.fm-r-paragraph {
  margin: 0;
  color: #475569;
  font-size: 0.9rem;
  white-space: pre-line;
}

.fm-choices {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.fm-choice {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--fm-line);
  border-radius: 10px;
  font-size: 0.88rem;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.fm-choice:hover {
  border-color: #c9d6ee;
}

.fm-choice.is-on {
  border-color: var(--fm-blue);
  background: var(--fm-blue-soft);
}

.fm-choice input {
  accent-color: var(--fm-blue);
  width: 1rem;
  height: 1rem;
  margin: 0;
}

.fm-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  padding: 1.35rem 1rem;
  border: 1.5px dashed #cdd6e5;
  border-radius: 12px;
  background: #fbfcfe;
  color: #64748b;
  text-align: center;
  font-size: 0.86rem;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.fm-drop svg {
  color: #64748b;
}

.fm-drop:hover,
.fm-drop.is-over {
  border-color: var(--fm-blue);
  background: var(--fm-blue-soft);
}

.fm-drop.is-disabled {
  cursor: default;
}

.fm-drop small {
  font-size: 0.74rem;
  color: #94a3b8;
}

.fm-link {
  color: var(--fm-blue);
  font-weight: 600;
}

.fm-file-list {
  list-style: none;
  margin: 0.5rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.fm-file-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.4rem 0.4rem 0.65rem;
  border: 1px solid var(--fm-line);
  border-radius: 9px;
  font-size: 0.84rem;
}

.fm-file-list li span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fm-file-list li small {
  color: var(--fm-muted);
}

.fm-submit {
  align-self: flex-start;
  padding: 0.7rem 1.6rem;
  font-size: 0.92rem;
}

.fm-form-error {
  margin: 0;
  color: #dc2626;
  font-size: 0.85rem;
  font-weight: 500;
}

.fm-hp {
  position: absolute !important;
  left: -9999px !important;
  width: 1px !important;
  height: 1px !important;
  opacity: 0 !important;
}

.fm-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  padding: 2.5rem 1.5rem;
  text-align: center;
}

.fm-success h3 {
  margin: 0.4rem 0 0;
  font-size: 1.2rem;
}

.fm-success p {
  margin: 0;
  color: #475569;
  max-width: 28rem;
}

.fm-success-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background: #e7f8ef;
  color: #16a34a;
  flex: 0 0 auto;
}

.fm-preview-frame {
  border: 1px solid var(--fm-line);
  border-radius: var(--fm-radius);
  overflow: hidden;
  max-width: 44rem;
  margin: 0 auto;
}

/* ---------- Settings tab ---------- */

.fm-settings {
  display: grid;
  grid-template-columns: 14rem minmax(0, 1fr) 17.5rem;
  gap: 1rem;
  align-items: start;
}

.fm-subnav {
  padding: 0.55rem;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  position: sticky;
  top: 1rem;
}

.fm-subnav-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 0.7rem;
  border: 0;
  border-radius: 9px;
  background: transparent;
  font: inherit;
  font-size: 0.86rem;
  font-weight: 500;
  color: #334155;
  text-align: left;
  cursor: pointer;
}

.fm-subnav-item svg {
  color: #64748b;
}

.fm-subnav-item:hover {
  background: #f5f7fb;
}

.fm-subnav-item.is-on {
  background: var(--fm-blue-soft);
  color: var(--fm-blue);
  font-weight: 600;
}

.fm-subnav-item.is-on svg {
  color: var(--fm-blue);
}

.fm-subnav-item.is-on::before {
  content: '';
  position: absolute;
  left: -0.55rem;
  top: 0.45rem;
  bottom: 0.45rem;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--fm-blue);
}

.fm-settings-main {
  padding: 1.25rem 1.35rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
}

.fm-section-head h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.fm-section-head p {
  margin: 0.2rem 0 0;
  color: var(--fm-muted);
  font-size: 0.82rem;
}

.fm-subsection {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding-top: 0.95rem;
  border-top: 1px solid var(--fm-line);
}

.fm-subsection h4 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
}

.fm-vars {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  align-items: center;
  font-size: 0.76rem;
  color: var(--fm-muted);
}

.fm-vars code {
  padding: 0.12rem 0.38rem;
  border-radius: 6px;
  background: #f1f4f9;
  color: #334155;
  font-size: 0.72rem;
}

.fm-form-type {
  padding: 1.1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  position: sticky;
  top: 1rem;
}

.fm-form-type > p {
  margin: -0.5rem 0 0;
  color: var(--fm-muted);
  font-size: 0.8rem;
}

.fm-radio-cards {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.fm-radio-card {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.7rem 0.75rem;
  border: 1px solid var(--fm-line);
  border-radius: 11px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.fm-radio-card:hover {
  border-color: #c9d6ee;
}

.fm-radio-card.is-on {
  border-color: var(--fm-blue);
  background: var(--fm-blue-soft);
}

.fm-radio-card input {
  margin-top: 0.2rem;
  width: 1rem;
  height: 1rem;
  accent-color: var(--fm-blue);
  flex: 0 0 auto;
}

.fm-radio-card strong {
  display: block;
  font-size: 0.87rem;
  font-weight: 600;
}

.fm-radio-card small {
  display: block;
  color: var(--fm-muted);
  font-size: 0.76rem;
  line-height: 1.4;
}

/* ---------- Automations ---------- */

.fm-automations {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 18rem;
  gap: 1rem;
  align-items: start;
}

.fm-auto-main {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.fm-auto-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.fm-auto-head h3 {
  margin: 0;
  font-size: 1.05rem;
}

.fm-auto-head p {
  margin: 0.2rem 0 0;
  color: var(--fm-muted);
  font-size: 0.84rem;
}

.fm-rule {
  padding: 1rem 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.fm-rule.is-off {
  opacity: 0.65;
}

.fm-rule-head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.fm-rule-head .fm-toggle {
  padding: 0;
  gap: 0.5rem;
}

.fm-rule-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 9px;
  background: #fff3df;
  color: #ea8a0c;
  flex: 0 0 auto;
}

.fm-rule-name {
  flex: 1;
  font-weight: 600 !important;
  border-color: transparent !important;
  padding-left: 0.4rem !important;
}

.fm-rule-name:hover {
  border-color: var(--fm-line-strong) !important;
}

.fm-rule-flow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.6rem;
  align-items: end;
}

.fm-rule-arrow {
  padding-bottom: 0.55rem;
  color: #94a3b8;
}

.fm-rule-config {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.85rem;
  background: var(--fm-bg-soft);
  border-radius: 11px;
}

.fm-rule-config:empty {
  display: none;
}

.fm-auto-builtins {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.fm-auto-builtins ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  font-size: 0.83rem;
}

.fm-auto-builtins li {
  display: flex;
  gap: 0.45rem;
  align-items: flex-start;
}

.fm-auto-builtins li svg {
  color: #16a34a;
  flex: 0 0 auto;
  margin-top: 0.15rem;
}

.fm-auto-builtins .fm-btn {
  align-self: flex-start;
}

/* ---------- Submissions ---------- */

.fm-subs {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.fm-bulkbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding: 0.55rem 0.8rem;
  border-radius: 11px;
  background: var(--fm-blue-soft);
  border: 1px solid #cfdcfb;
  font-size: 0.86rem;
}

.fm-bulkbar strong {
  margin-right: 0.35rem;
  color: var(--fm-blue);
}

.fm-person {
  display: flex;
  flex-direction: column;
}

.fm-person strong {
  font-weight: 600;
}

.fm-person small,
.fm-when small {
  color: var(--fm-muted);
  font-size: 0.76rem;
}

.fm-when {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}

.fm-status-stack {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.fm-sub-status {
  display: inline-flex;
  padding: 0.2rem 0.6rem;
  border-radius: 7px;
  font-size: 0.75rem;
  font-weight: 600;
}

.fm-sub-status--new {
  background: #e9f0ff;
  color: #2459d9;
}

.fm-sub-status--reviewed {
  background: #e7f8ef;
  color: #15803d;
}

.fm-late {
  display: inline-flex;
  padding: 0.2rem 0.55rem;
  border-radius: 7px;
  background: #fdeaea;
  color: #dc2626;
  font-size: 0.74rem;
  font-weight: 600;
}

.fm-ontime {
  font-size: 0.78rem;
  color: #15803d;
  font-weight: 500;
}

.fm-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.15rem 0.4rem;
  border-radius: 6px;
  background: #f1f4f9;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 600;
}

.fm-drawer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgb(15 23 42 / 35%);
  display: flex;
  justify-content: flex-end;
  animation: fm-fade 0.15s ease;
}

.fm-drawer {
  --fm-blue: #1463ff;
  --fm-blue-soft: #eef4ff;
  --fm-line: #e6eaf2;
  --fm-line-strong: #d7deea;
  --fm-muted: #64748b;
  --fm-ink: #0f172a;
  --fm-bg-soft: #f7f9fc;
  width: min(38rem, 100%);
  height: 100%;
  background: #fff;
  box-shadow: -12px 0 40px rgb(15 23 42 / 18%);
  display: flex;
  flex-direction: column;
  animation: fm-slide 0.2s ease;
}

@keyframes fm-fade {
  from {
    opacity: 0;
  }
}

@keyframes fm-slide {
  from {
    transform: translateX(2rem);
    opacity: 0;
  }
}

.fm-drawer-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem 1.4rem 0.9rem;
  border-bottom: 1px solid var(--fm-line);
}

.fm-drawer-head h2 {
  margin: 0.15rem 0 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.fm-drawer-head p {
  margin: 0.2rem 0 0;
  color: var(--fm-muted);
  font-size: 0.84rem;
}

.fm-drawer-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding: 0.8rem 1.4rem;
  background: var(--fm-bg-soft);
  border-bottom: 1px solid var(--fm-line);
}

.fm-drawer-status-actions {
  margin-left: auto;
}

.fm-drawer-reviewed {
  padding: 0.5rem 1.4rem 0;
}

.fm-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 1.1rem 1.4rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
}

.fm-answers {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  margin: 0;
}

.fm-answers-heading {
  margin: 0.9rem 0 0.3rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--fm-muted);
}

.fm-answers-heading:first-child {
  margin-top: 0;
}

.fm-answer {
  padding: 0.75rem 0;
  border-bottom: 1px solid #eef1f6;
}

.fm-answer dt {
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.25rem;
}

.fm-answer dd {
  margin: 0;
  font-size: 0.93rem;
  color: var(--fm-ink);
}

.fm-answer-text {
  white-space: pre-wrap;
  word-break: break-word;
}

.fm-empty-answer {
  color: #a0aabb;
  font-style: italic;
}

.fm-answer-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.fm-answer-tags span {
  padding: 0.18rem 0.55rem;
  border-radius: 7px;
  background: var(--fm-blue-soft);
  color: var(--fm-blue);
  font-size: 0.8rem;
  font-weight: 600;
}

.fm-answer-files {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.fm-answer-files li {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 0.55rem 0.5rem 0.7rem;
  border: 1px solid var(--fm-line);
  border-radius: 10px;
}

.fm-answer-files li > span {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  font-size: 0.86rem;
  word-break: break-all;
}

.fm-answer-files small {
  color: var(--fm-muted);
  font-size: 0.74rem;
}

.fm-notes,
.fm-log {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.fm-notes h4,
.fm-log h4 {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  font-size: 0.86rem;
  font-weight: 700;
}

.fm-notes textarea {
  width: 100%;
  padding: 0.65rem 0.8rem;
  border: 1px solid #f1d58a;
  border-radius: 10px;
  background: #fffdf3;
  font: inherit;
  font-size: 0.88rem;
  resize: vertical;
  outline: none;
}

.fm-notes textarea:focus {
  border-color: #eab308;
  box-shadow: 0 0 0 3px rgb(234 179 8 / 15%);
}

.fm-notes-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--fm-muted);
}

.fm-log ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.8rem;
}

.fm-log li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: #334155;
}

.fm-log li > span:nth-child(2) {
  flex: 1;
}

.fm-log li strong {
  text-transform: capitalize;
}

.fm-log li small {
  color: var(--fm-muted);
}

.fm-log-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  margin-top: 0.35rem;
  background: #22c55e;
  flex: 0 0 auto;
}

.fm-log li.is-fail .fm-log-dot {
  background: #ef4444;
}

.fm-drawer-meta {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));
  gap: 0.75rem;
  padding: 0.9rem;
  border-radius: 11px;
  background: var(--fm-bg-soft);
}

.fm-drawer-meta dt {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--fm-muted);
}

.fm-drawer-meta dd {
  margin: 0.15rem 0 0;
  font-size: 0.85rem;
  word-break: break-all;
}

.fm-drawer-foot {
  padding: 0.8rem 1.4rem;
  border-top: 1px solid var(--fm-line);
  display: flex;
  justify-content: flex-start;
}

/* ---------- Public page ---------- */

.fm-public {
  min-height: 100vh;
  padding: 2.5rem 1rem 3rem;
  background:
    radial-gradient(circle at 0% 0%, rgb(20 99 255 / 8%), transparent 40%),
    radial-gradient(circle at 100% 100%, rgb(109 63 216 / 8%), transparent 40%),
    #f4f6fb;
  color: var(--fm-ink);
}

.fm-public.is-embed {
  min-height: 0;
  padding: 0;
  background: transparent;
}

.fm-public-inner {
  max-width: 44rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fm-public.is-embed .fm-public-inner {
  max-width: none;
}

.fm-public-org {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  font-weight: 700;
  font-size: 1rem;
  color: #334155;
}

.fm-public-org img {
  max-height: 2.2rem;
  max-width: 10rem;
  object-fit: contain;
}

.fm-public-card {
  overflow: hidden;
}

.fm-public.is-embed .fm-public-card {
  box-shadow: none;
}

.fm-public-msg {
  padding: 2.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: var(--fm-muted);
}

/* ---------- Client portal ---------- */

.fm-portal {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: var(--fm-ink);
}

.fm-portal-section {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.fm-portal-section h2 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.fm-portal-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.fm-portal-card {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.95rem 1.1rem;
  color: inherit;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.fm-portal-card:hover {
  text-decoration: none;
  border-color: #b8cdfb;
  box-shadow: 0 6px 18px rgb(15 23 42 / 8%);
}

.fm-portal-card-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.fm-portal-card-text strong {
  font-weight: 600;
}

.fm-portal-card-text small {
  color: var(--fm-muted);
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fm-portal-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  font-size: 0.76rem;
  color: var(--fm-muted);
}

.fm-portal-card-meta .is-late {
  color: #dc2626;
  font-weight: 600;
}

.fm-portal-card-cta {
  color: var(--fm-blue);
  font-weight: 600;
  font-size: 0.86rem;
}

.fm-portal-fill .fm-public-card,
.fm-portal-done {
  max-width: 46rem;
}

.fm-portal-done {
  padding: 1.3rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fm-portal-done-head {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  flex-wrap: wrap;
}

.fm-portal-done-head > div {
  flex: 1;
}

.fm-portal-done-head h2 {
  margin: 0;
  font-size: 1.2rem;
}

.fm-portal-done-head p {
  margin: 0.15rem 0 0;
  color: var(--fm-muted);
  font-size: 0.85rem;
}

.fm-due-note {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  width: fit-content;
  padding: 0.3rem 0.65rem;
  border-radius: 8px;
  background: #f1f4f9;
  color: #334155;
  font-size: 0.8rem;
  font-weight: 600;
}

.fm-due-note.is-late {
  background: #fdeaea;
  color: #dc2626;
}

/* ---------- Responsive ---------- */

@media (max-width: 1280px) {
  .fm-build {
    grid-template-columns: 12.5rem minmax(0, 1fr) 16.5rem;
  }

  .fm-settings {
    grid-template-columns: 12.5rem minmax(0, 1fr);
  }

  .fm-form-type {
    grid-column: 1 / -1;
    position: static;
  }

  .fm-radio-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {
  .fm-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .fm-build {
    grid-template-columns: 1fr;
  }

  .fm-palette,
  .fm-side {
    position: static;
  }

  .fm-palette ul {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(9rem, 1fr));
  }

  .fm-automations {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 760px) {
  .fm-page-head,
  .fm-editor-head {
    flex-direction: column;
  }

  .fm-editor-actions {
    justify-content: flex-start;
  }

  .fm-stats,
  .fm-grid-2,
  .fm-grid-3,
  .fm-settings,
  .fm-radio-cards,
  .fm-type-grid {
    grid-template-columns: 1fr;
  }

  .fm-subnav {
    position: static;
    flex-direction: row;
    overflow-x: auto;
  }

  .fm-subnav-item.is-on::before {
    display: none;
  }

  .fm-table-card {
    overflow-x: auto;
  }

  .fm-search {
    min-width: 0;
    flex: 1;
  }

  .fm-rule-flow {
    grid-template-columns: 1fr;
  }

  .fm-rule-arrow {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/forms/forms.css"],"names":[],"mappings":"AAAA,2FAA2F;;AAE3F;;;;EAIE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,kCAAkC;;AAElC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;;AAExC;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;;EAME,WAAW;EACX,wBAAwB;EACxB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;;EAME,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,OAAO;EACP,sEAAsE;EACtE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,+CAA+C;;AAE/C;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;;EAIE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,iFAAiF;;AAEjF;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX;;;kEAGgE;AAClE;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;EACb,2BAA2B;AAC7B;;AAEA,sCAAsC;;AAEtC;EACE,iBAAiB;EACjB,yBAAyB;EACzB;;;WAGS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE;IACE,qDAAqD;EACvD;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2DAA2D;EAC7D;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;;;IAME,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Forms feature (library, builder, settings, automations, submissions, public + portal). */\n\n.fm-page,\n.fm-public,\n.fm-portal,\n.modal-panel {\n  --fm-blue: #1463ff;\n  --fm-blue-hover: #0b52e6;\n  --fm-blue-soft: #eef4ff;\n  --fm-ink: #0f172a;\n  --fm-muted: #64748b;\n  --fm-line: #e6eaf2;\n  --fm-line-strong: #d7deea;\n  --fm-bg-soft: #f7f9fc;\n  --fm-radius: 14px;\n  --fm-shadow: 0 1px 2px rgb(15 23 42 / 4%), 0 4px 14px rgb(15 23 42 / 4%);\n}\n\n.fm-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1.15rem;\n  color: var(--fm-ink);\n}\n\n.fm-card {\n  background: #fff;\n  border: 1px solid var(--fm-line);\n  border-radius: var(--fm-radius);\n  box-shadow: var(--fm-shadow);\n}\n\n/* ---------- Buttons ---------- */\n\n.fm-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 0.55rem 1rem;\n  border-radius: 10px;\n  border: 1px solid var(--fm-line-strong);\n  background: #fff;\n  color: var(--fm-ink);\n  font: inherit;\n  font-size: 0.88rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s, color 0.15s, box-shadow 0.15s;\n}\n\n.fm-btn:hover:not(:disabled) {\n  border-color: #b9c5da;\n  background: var(--fm-bg-soft);\n}\n\n.fm-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.fm-btn--blue {\n  background: var(--fm-blue);\n  border-color: var(--fm-blue);\n  color: #fff;\n  box-shadow: 0 2px 6px rgb(20 99 255 / 25%);\n}\n\n.fm-btn--blue:hover:not(:disabled) {\n  background: var(--fm-blue-hover);\n  border-color: var(--fm-blue-hover);\n  color: #fff;\n}\n\n.fm-btn--outline-blue {\n  border-color: #b8cdfb;\n  color: var(--fm-blue);\n}\n\n.fm-btn--outline-blue:hover:not(:disabled) {\n  background: var(--fm-blue-soft);\n  border-color: var(--fm-blue);\n}\n\n.fm-btn--outline-danger {\n  border-color: #f5b5b5;\n  color: #dc2626;\n}\n\n.fm-btn--outline-danger:hover:not(:disabled) {\n  background: #fef2f2;\n  border-color: #ef4444;\n}\n\n.fm-btn--danger-solid {\n  background: #dc2626;\n  border-color: #dc2626;\n  color: #fff;\n}\n\n.fm-btn--danger-solid:hover:not(:disabled) {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.fm-btn--ghost {\n  border-color: transparent;\n  background: transparent;\n  color: var(--fm-blue);\n  padding-left: 0.2rem;\n}\n\n.fm-btn--lg {\n  padding: 0.75rem 1.35rem;\n  font-size: 0.95rem;\n}\n\n.fm-btn--wide {\n  min-width: 5.5rem;\n}\n\n.fm-btn--sm {\n  padding: 0.38rem 0.7rem;\n  font-size: 0.8rem;\n  border-radius: 8px;\n}\n\n.fm-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #475569;\n  cursor: pointer;\n  padding: 0;\n}\n\n.fm-icon-btn:hover:not(:disabled),\n.fm-icon-btn.is-open {\n  background: #f1f4f9;\n  color: var(--fm-ink);\n}\n\n.fm-icon-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.fm-icon-btn.is-danger:hover:not(:disabled) {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.fm-link-btn {\n  background: none;\n  border: 0;\n  color: var(--fm-blue);\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.fm-flip {\n  transform: rotate(180deg);\n}\n\n/* ---------- Alerts / misc ---------- */\n\n.fm-alert {\n  margin: 0;\n  padding: 0.65rem 0.9rem;\n  border-radius: 10px;\n  font-size: 0.86rem;\n  font-weight: 500;\n}\n\n.fm-alert--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.fm-alert--ok {\n  background: #ecfdf3;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.fm-alert--warn {\n  background: #fff8eb;\n  color: #9a5b00;\n  border: 1px solid #fde3b0;\n}\n\n.fm-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 2.5rem 1rem;\n  color: var(--fm-muted);\n  text-align: center;\n  margin: 0;\n}\n\n.fm-empty p {\n  margin: 0;\n}\n\n.fm-hint {\n  display: block;\n  margin: 0;\n  color: var(--fm-muted);\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n\n.fm-hint.is-warn {\n  color: #b45309;\n}\n\n.fm-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: #475569;\n  font-size: 0.88rem;\n  font-weight: 500;\n  width: fit-content;\n}\n\n.fm-back:hover {\n  color: var(--fm-blue);\n  text-decoration: none;\n}\n\n.fm-eyebrow {\n  font-size: 0.7rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--fm-muted);\n}\n\n/* ---------- Library ---------- */\n\n.fm-page-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.fm-page-head h1,\n.fm-editor-title h1 {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--fm-ink);\n}\n\n.fm-page-head p,\n.fm-editor-title p {\n  margin: 0.3rem 0 0;\n  color: var(--fm-muted);\n  font-size: 0.92rem;\n}\n\n.fm-stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.fm-stat {\n  display: flex;\n  align-items: center;\n  gap: 0.95rem;\n  padding: 1.15rem 1.2rem;\n  background: #fff;\n  border: 1px solid var(--fm-line);\n  border-radius: var(--fm-radius);\n  box-shadow: var(--fm-shadow);\n  text-align: left;\n  font: inherit;\n  color: inherit;\n}\n\n.fm-stat.is-clickable {\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;\n}\n\n.fm-stat.is-clickable:hover {\n  border-color: #c9d6ee;\n  box-shadow: 0 6px 18px rgb(15 23 42 / 8%);\n}\n\n.fm-stat.is-active {\n  border-color: var(--fm-blue);\n  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);\n}\n\n.fm-stat-icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 12px;\n}\n\n.fm-stat-icon--purple {\n  background: #f1ecff;\n  color: #6d3fd8;\n}\n\n.fm-stat-icon--green {\n  background: #e7f8ef;\n  color: #16a34a;\n}\n\n.fm-stat-icon--amber {\n  background: #fff3df;\n  color: #ea8a0c;\n}\n\n.fm-stat-icon--red {\n  background: #fdeaea;\n  color: #dc2626;\n}\n\n.fm-stat-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.fm-stat-text strong {\n  font-size: 1.6rem;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.fm-stat-text > span {\n  color: #475569;\n  font-size: 0.86rem;\n}\n\n.fm-stat-text em {\n  font-style: normal;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #dc2626;\n}\n\n.fm-stat-sub--blue {\n  color: var(--fm-blue);\n}\n\n.fm-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.fm-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n.fm-chips {\n  display: flex;\n  gap: 0.45rem;\n  flex-wrap: wrap;\n}\n\n.fm-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.85rem;\n  border-radius: 9px;\n  border: 1px solid var(--fm-line);\n  background: #fff;\n  color: #334155;\n  font: inherit;\n  font-size: 0.84rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.fm-chip:hover {\n  border-color: #c9d6ee;\n}\n\n.fm-chip.is-on {\n  background: var(--fm-blue);\n  border-color: var(--fm-blue);\n  color: #fff;\n}\n\n.fm-chip--filter {\n  background: #fff8eb;\n  border-color: #fde3b0;\n  color: #9a5b00;\n}\n\n.fm-chip-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: #eef2f8;\n  color: #475569;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.fm-chip.is-on .fm-chip-count {\n  background: rgb(255 255 255 / 22%);\n  color: #fff;\n}\n\n.fm-search {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 12.5rem;\n  padding: 0 0.75rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 10px;\n  background: #fff;\n  color: #94a3b8;\n}\n\n.fm-search:focus-within {\n  border-color: var(--fm-blue);\n  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);\n}\n\n.fm-search input {\n  flex: 1;\n  border: 0;\n  outline: none;\n  padding: 0.55rem 0;\n  font: inherit;\n  font-size: 0.86rem;\n  background: transparent;\n  color: var(--fm-ink);\n  min-width: 0;\n}\n\n.fm-sort {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0 0.6rem 0 0.75rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 10px;\n  background: #fff;\n  color: var(--fm-muted);\n  font-size: 0.84rem;\n}\n\n.fm-sort select,\n.fm-sort .searchable-select-trigger {\n  appearance: none;\n  border: 0;\n  background-color: transparent;\n  background-image: none;\n  box-shadow: none;\n  font: inherit;\n  font-weight: 600;\n  color: var(--fm-ink);\n  padding: 0.55rem 1.3rem 0.55rem 0;\n  cursor: pointer;\n  outline: none;\n  width: auto;\n  min-width: 6rem;\n  border-radius: 0;\n}\n\n.fm-sort .searchable-select {\n  width: auto;\n  flex: 1;\n  min-width: 0;\n}\n\n.fm-sort svg {\n  position: absolute;\n  right: 0.6rem;\n  pointer-events: none;\n}\n\n.fm-table-card {\n  overflow: visible;\n}\n\n.fm-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.88rem;\n}\n\n.fm-table th {\n  text-align: left;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--fm-muted);\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--fm-line);\n  background: #fbfcfe;\n  white-space: nowrap;\n}\n\n.fm-table th:first-child {\n  border-top-left-radius: var(--fm-radius);\n}\n\n.fm-table th:last-child {\n  border-top-right-radius: var(--fm-radius);\n}\n\n.fm-table td {\n  padding: 0.8rem 1rem;\n  border-bottom: 1px solid #eef1f6;\n  vertical-align: middle;\n  color: var(--fm-ink);\n}\n\n.fm-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.fm-table tr.is-link {\n  cursor: pointer;\n}\n\n.fm-table tbody tr.is-link:hover td {\n  background: #f8faff;\n}\n\n.fm-table tr.is-current td {\n  background: var(--fm-blue-soft);\n}\n\n.fm-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  font-weight: 600;\n}\n\n.fm-page .fm-name-cell a {\n  color: var(--fm-ink);\n}\n\n.fm-page .fm-name-cell a:hover {\n  color: var(--fm-blue);\n  text-decoration: none;\n}\n\n.fm-new-dot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.15rem;\n  height: 1.15rem;\n  padding: 0 0.3rem;\n  border-radius: 999px;\n  background: var(--fm-blue);\n  color: #fff;\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.fm-row-icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 8px;\n}\n\n.fm-row-icon--website_form {\n  background: #e7f8ef;\n  color: #16a34a;\n}\n\n.fm-row-icon--questionnaire {\n  background: #fdeaf6;\n  color: #d63c98;\n}\n\n.fm-row-icon--client_request {\n  background: #f1ecff;\n  color: #6d3fd8;\n}\n\n.fm-row-icon--template {\n  background: #f1ecff;\n  color: #8b5cf6;\n}\n\n.fm-muted-cell {\n  color: #475569 !important;\n}\n\n.fm-due {\n  font-size: 0.74rem;\n  color: var(--fm-muted);\n  margin-top: 0.1rem;\n}\n\n.fm-due.is-late {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.fm-actions-cell {\n  width: 3rem;\n  text-align: right;\n}\n\n.fm-check-cell {\n  width: 2.75rem;\n}\n\n.fm-check-cell input {\n  width: 1rem;\n  height: 1rem;\n  accent-color: var(--fm-blue);\n  cursor: pointer;\n}\n\n.fm-type {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.22rem 0.6rem;\n  border-radius: 7px;\n  font-size: 0.76rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.fm-type--website_form {\n  background: #e9f0ff;\n  color: #2459d9;\n}\n\n.fm-type--questionnaire {\n  background: #f1ecff;\n  color: #6d3fd8;\n}\n\n.fm-type--client_request {\n  background: #fdecf6;\n  color: #d43d95;\n}\n\n.fm-type--template {\n  background: #f1f3f7;\n  color: #475569;\n}\n\n.fm-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.24rem 0.65rem;\n  border-radius: 999px;\n  font-size: 0.76rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.fm-status-dot {\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.fm-status--green {\n  background: #e7f8ef;\n  color: #15803d;\n}\n\n.fm-status--amber {\n  background: #fff3df;\n  color: #c2610c;\n}\n\n.fm-status--red {\n  background: #fdeaea;\n  color: #dc2626;\n}\n\n.fm-status--gray {\n  background: #f1f3f7;\n  color: #64748b;\n}\n\n.fm-status--slate {\n  background: #eef1f6;\n  color: #334155;\n}\n\n.fm-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  border-top: 1px solid var(--fm-line);\n  color: var(--fm-muted);\n  font-size: 0.84rem;\n}\n\n.fm-pager-btns {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.fm-pager-num {\n  min-width: 2rem;\n  height: 2rem;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  font: inherit;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n}\n\n.fm-pager-num:hover {\n  background: #f1f4f9;\n}\n\n.fm-pager-num.is-on {\n  background: var(--fm-blue);\n  color: #fff;\n}\n\n.fm-pager-gap {\n  padding: 0 0.25rem;\n}\n\n/* ---------- Menu ---------- */\n\n.fm-menu {\n  position: relative;\n  display: inline-flex;\n}\n\n.fm-menu-list {\n  position: absolute;\n  top: calc(100% + 0.3rem);\n  z-index: 40;\n  min-width: 13rem;\n  padding: 0.35rem;\n  background: #fff;\n  border: 1px solid var(--fm-line);\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgb(15 23 42 / 14%);\n  display: flex;\n  flex-direction: column;\n}\n\n.fm-menu-list--right {\n  right: 0;\n}\n\n.fm-menu-list--left {\n  left: 0;\n}\n\n.fm-menu-list button {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  width: 100%;\n  padding: 0.55rem 0.65rem;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  font: inherit;\n  font-size: 0.86rem;\n  color: #1e293b;\n  text-align: left;\n  cursor: pointer;\n}\n\n.fm-menu-list button svg {\n  color: #64748b;\n}\n\n.fm-menu-list button:hover:not(:disabled) {\n  background: #f3f6fb;\n}\n\n.fm-menu-list button.is-danger,\n.fm-menu-list button.is-danger svg {\n  color: #dc2626;\n}\n\n.fm-menu-list button.is-danger:hover {\n  background: #fef2f2;\n}\n\n/* ---------- Form controls (admin) ---------- */\n\n.fm-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n.fm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin: 0;\n}\n\n.fm-field > span,\n.fm-field-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.fm-field > span em {\n  font-style: normal;\n  font-weight: 400;\n  color: var(--fm-muted);\n}\n\n.fm-field input:not([type='checkbox']):not([type='radio']),\n.fm-field select,\n.fm-field .searchable-select-trigger,\n.fm-field textarea,\n.fm-option-row input,\n.fm-rule-name {\n  width: 100%;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid var(--fm-line-strong);\n  border-radius: 9px;\n  background: #fff;\n  font: inherit;\n  font-size: 0.87rem;\n  color: var(--fm-ink);\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.fm-field textarea {\n  resize: vertical;\n  min-height: 4.5rem;\n  line-height: 1.45;\n}\n\n.fm-field input:focus,\n.fm-field select:focus,\n.fm-field .searchable-select-trigger:focus,\n.fm-field textarea:focus,\n.fm-option-row input:focus,\n.fm-rule-name:focus {\n  border-color: var(--fm-blue);\n  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);\n}\n\n.fm-field input:disabled,\n.fm-field select:disabled {\n  background: #f6f8fb;\n  color: #94a3b8;\n}\n\n.fm-select-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.fm-select-wrap select,\n.fm-select-wrap .searchable-select-trigger {\n  appearance: none;\n  padding-right: 2.2rem !important;\n  cursor: pointer;\n  background-image: none;\n  box-shadow: none;\n}\n\n.fm-select-wrap .searchable-select {\n  flex: 1;\n  min-width: 0;\n}\n\n.fm-select-wrap > svg {\n  position: absolute;\n  right: 0.7rem;\n  pointer-events: none;\n  color: #64748b;\n}\n\n.fm-select-clear select,\n.fm-select-clear .searchable-select-trigger {\n  padding-right: 3.6rem !important;\n}\n\n.fm-clear-btn {\n  position: absolute;\n  right: 2.1rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.4rem;\n  height: 1.4rem;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.fm-clear-btn:hover {\n  background: #f1f4f9;\n  color: #0f172a;\n}\n\n.fm-input-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.fm-input-icon > svg {\n  position: absolute;\n  left: 0.75rem;\n  color: #64748b;\n  pointer-events: none;\n}\n\n.fm-input-icon input {\n  padding-left: 2.35rem !important;\n}\n\n.fm-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  font-size: 0.84rem;\n  color: #1e293b;\n  cursor: pointer;\n}\n\n.fm-check input {\n  margin-top: 0.15rem;\n  width: 1rem;\n  height: 1rem;\n  accent-color: var(--fm-blue);\n  flex: 0 0 auto;\n}\n\n.fm-check small {\n  display: block;\n  color: var(--fm-muted);\n  font-size: 0.76rem;\n}\n\n.fm-check.is-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.fm-toggle {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.7rem 0;\n  cursor: pointer;\n}\n\n.fm-toggle-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.fm-toggle-text strong {\n  font-size: 0.87rem;\n  font-weight: 600;\n}\n\n.fm-toggle-text small {\n  color: var(--fm-muted);\n  font-size: 0.77rem;\n}\n\n.fm-toggle input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.fm-toggle-track {\n  position: relative;\n  flex: 0 0 auto;\n  width: 2.4rem;\n  height: 1.35rem;\n  border-radius: 999px;\n  background: #d5dce8;\n  transition: background 0.15s;\n}\n\n.fm-toggle-track::after {\n  content: '';\n  position: absolute;\n  top: 0.15rem;\n  left: 0.15rem;\n  width: 1.05rem;\n  height: 1.05rem;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgb(15 23 42 / 25%);\n  transition: transform 0.15s;\n}\n\n.fm-toggle input:checked + .fm-toggle-track {\n  background: var(--fm-blue);\n}\n\n.fm-toggle input:checked + .fm-toggle-track::after {\n  transform: translateX(1.05rem);\n}\n\n.fm-toggle input:focus-visible + .fm-toggle-track {\n  box-shadow: 0 0 0 3px rgb(20 99 255 / 25%);\n}\n\n.fm-toggle.is-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.fm-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.9rem;\n}\n\n.fm-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.9rem;\n}\n\n.fm-seg {\n  display: inline-flex;\n  padding: 0.2rem;\n  border-radius: 10px;\n  background: #f1f4f9;\n  gap: 0.2rem;\n  width: fit-content;\n  flex-wrap: wrap;\n}\n\n.fm-seg button {\n  border: 0;\n  border-radius: 8px;\n  padding: 0.42rem 0.8rem;\n  background: transparent;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n}\n\n.fm-seg button.is-on {\n  background: #fff;\n  color: var(--fm-blue);\n  box-shadow: 0 1px 3px rgb(15 23 42 / 10%);\n}\n\n.fm-copy {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n}\n\n.fm-copy input,\n.fm-copy textarea {\n  flex: 1;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace !important;\n  font-size: 0.78rem !important;\n  background: var(--fm-bg-soft) !important;\n}\n\n.fm-copy.is-multi {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.fm-copy.is-multi .fm-btn {\n  align-self: flex-end;\n}\n\n.fm-type-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.5rem;\n}\n\n.fm-type-option {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.6rem 0.75rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.fm-type-option input {\n  accent-color: var(--fm-blue);\n}\n\n.fm-type-option.is-on {\n  border-color: var(--fm-blue);\n  background: var(--fm-blue-soft);\n}\n\n/* ---------- Editor header / tabs ---------- */\n\n.fm-editor {\n  gap: 0.9rem;\n}\n\n.fm-editor-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.fm-editor-title {\n  min-width: 0;\n}\n\n.fm-editor-title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  flex-wrap: wrap;\n}\n\n.fm-editor-title h1 {\n  font-size: 1.55rem;\n}\n\n.fm-unsaved {\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: #b45309;\n  background: #fff8eb;\n  border-radius: 999px;\n  padding: 0.18rem 0.6rem;\n}\n\n.fm-editor-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.fm-tabs {\n  display: flex;\n  gap: 0.25rem;\n  border-bottom: 1px solid var(--fm-line);\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n}\n\n.fm-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.65rem 1.1rem;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.fm-tab:hover {\n  color: var(--fm-ink);\n}\n\n.fm-tab.is-on {\n  color: var(--fm-blue);\n  font-weight: 600;\n}\n\n.fm-tab.is-on::after {\n  content: '';\n  position: absolute;\n  left: 0.6rem;\n  right: 0.6rem;\n  bottom: -1px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--fm-blue);\n}\n\n.fm-tab-badge {\n  min-width: 1.15rem;\n  height: 1.15rem;\n  padding: 0 0.3rem;\n  border-radius: 999px;\n  background: var(--fm-blue);\n  color: #fff;\n  font-size: 0.68rem;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ---------- Build tab ---------- */\n\n.fm-build {\n  display: grid;\n  grid-template-columns: 14rem minmax(0, 1fr) 18.5rem;\n  gap: 1rem;\n  align-items: start;\n}\n\n.fm-palette {\n  padding: 1rem 0.85rem;\n  position: sticky;\n  top: 1rem;\n}\n\n.fm-palette h3,\n.fm-side h3,\n.fm-form-type h3,\n.fm-auto-builtins h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.fm-palette > p {\n  margin: 0.2rem 0 0.75rem;\n  color: var(--fm-muted);\n  font-size: 0.78rem;\n}\n\n.fm-palette ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.fm-palette button {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  width: 100%;\n  padding: 0.45rem 0.55rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 9px;\n  background: #fff;\n  font: inherit;\n  font-size: 0.84rem;\n  font-weight: 500;\n  color: #1e293b;\n  cursor: grab;\n  text-align: left;\n  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;\n}\n\n.fm-palette button:hover {\n  border-color: #b8cdfb;\n  background: #fafcff;\n  box-shadow: 0 2px 6px rgb(20 99 255 / 8%);\n}\n\n.fm-palette button:active {\n  cursor: grabbing;\n}\n\n.fm-palette-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 7px;\n  background: #f1ecff;\n  color: #6d3fd8;\n  flex: 0 0 auto;\n}\n\n.fm-palette-label {\n  flex: 1;\n}\n\n.fm-grip {\n  color: #a3adbf;\n}\n\n.fm-canvas {\n  overflow: hidden;\n  min-height: 30rem;\n  transition: box-shadow 0.15s;\n}\n\n.fm-canvas.is-dropping {\n  box-shadow: 0 0 0 2px rgb(20 99 255 / 25%), var(--fm-shadow);\n}\n\n.fm-canvas-title {\n  padding: 1.5rem 1.5rem 0.5rem;\n}\n\n.fm-canvas-title h2 {\n  margin: 0;\n  font-size: 1.3rem;\n}\n\n.fm-canvas-title p {\n  margin: 0.3rem 0 0;\n  color: var(--fm-muted);\n}\n\n.fm-canvas-body {\n  padding: 1.1rem 1.25rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.fm-canvas-field {\n  position: relative;\n  padding: 0.7rem 0.85rem 0.7rem 1.6rem;\n  border: 1px solid transparent;\n  border-radius: 11px;\n  cursor: pointer;\n  transition: border-color 0.12s, background 0.12s;\n  outline: none;\n}\n\n.fm-canvas-field:hover {\n  border-color: #dbe4f3;\n  background: #fbfcff;\n}\n\n.fm-canvas-field:focus-visible {\n  border-color: #b8cdfb;\n}\n\n.fm-canvas-field.is-selected {\n  border-color: var(--fm-blue);\n  background: #f8fbff;\n  box-shadow: 0 0 0 3px rgb(20 99 255 / 10%);\n}\n\n.fm-canvas-field.is-dragging {\n  opacity: 0.4;\n}\n\n.fm-canvas-grip {\n  position: absolute;\n  left: 0.35rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #b4bdcc;\n  opacity: 0;\n  cursor: grab;\n}\n\n.fm-canvas-field:hover .fm-canvas-grip,\n.fm-canvas-field.is-selected .fm-canvas-grip {\n  opacity: 1;\n}\n\n.fm-canvas-control {\n  pointer-events: none;\n}\n\n.fm-canvas-control .fm-r-field input:disabled,\n.fm-canvas-control .fm-r-field textarea:disabled,\n.fm-canvas-control .fm-r-field select:disabled {\n  background: #fff;\n  color: #94a3b8;\n  opacity: 1;\n}\n\n.fm-canvas-tools {\n  position: absolute;\n  top: -0.85rem;\n  right: 0.75rem;\n  display: flex;\n  gap: 0.1rem;\n  padding: 0.15rem;\n  border-radius: 9px;\n  background: #fff;\n  border: 1px solid var(--fm-line);\n  box-shadow: 0 4px 12px rgb(15 23 42 / 10%);\n}\n\n.fm-canvas-tools .fm-icon-btn {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.fm-drop-line {\n  height: 3px;\n  border-radius: 3px;\n  background: var(--fm-blue);\n  box-shadow: 0 0 0 3px rgb(20 99 255 / 15%);\n  margin: 0.15rem 0;\n}\n\n.fm-canvas-end {\n  margin-top: 0.4rem;\n  padding: 0.9rem;\n  border: 1.5px dashed #d3dceb;\n  border-radius: 11px;\n  color: #94a3b8;\n  font-size: 0.82rem;\n  text-align: center;\n}\n\n.fm-canvas.is-dropping .fm-canvas-end {\n  border-color: var(--fm-blue);\n  color: var(--fm-blue);\n  background: var(--fm-blue-soft);\n}\n\n.fm-submit.is-static {\n  pointer-events: none;\n  margin-top: 0.75rem;\n}\n\n.fm-side {\n  padding: 1.1rem 1rem;\n  position: sticky;\n  top: 1rem;\n}\n\n.fm-side-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.fm-side h3 span {\n  font-weight: 400;\n  color: var(--fm-muted);\n}\n\n.fm-side-checks {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding-top: 0.25rem;\n}\n\n.fm-side-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  border: 0;\n  background: none;\n  padding: 0;\n  color: var(--fm-blue);\n  font: inherit;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.fm-inspector-title {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.fm-inspector-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding-top: 0.6rem;\n  border-top: 1px solid var(--fm-line);\n}\n\n.fm-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.fm-option-row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.fm-option-row input {\n  padding: 0.42rem 0.6rem;\n}\n\n.fm-option-mark {\n  flex: 0 0 auto;\n  width: 0.9rem;\n  height: 0.9rem;\n  border: 1.5px solid #a3adbf;\n  border-radius: 4px;\n}\n\n.fm-option-mark--radio {\n  border-radius: 50%;\n}\n\n.fm-option-mark--select {\n  border-radius: 2px;\n  border-width: 0 0 2px;\n  height: 0.5rem;\n}\n\n.fm-ext-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.fm-ext {\n  padding: 0.22rem 0.45rem;\n  border-radius: 6px;\n  border: 1px solid var(--fm-line);\n  background: #fff;\n  font: inherit;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n}\n\n.fm-ext.is-on {\n  border-color: var(--fm-blue);\n  background: var(--fm-blue-soft);\n  color: var(--fm-blue);\n}\n\n/* ---------- Respondent rendering (canvas, preview, public, portal) ---------- */\n\n.fm-banner {\n  position: relative;\n  padding: 1.75rem 1.6rem;\n  color: #fff;\n  background:\n    radial-gradient(circle at 85% 20%, rgb(99 102 241 / 35%), transparent 45%),\n    radial-gradient(circle at 10% 110%, rgb(20 99 255 / 30%), transparent 45%),\n    linear-gradient(135deg, #0b1220 0%, #16213b 55%, #1d2b4f 100%);\n}\n\n.fm-banner h2 {\n  margin: 0;\n  color: #fff;\n  font-size: 1.4rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.fm-banner p {\n  margin: 0.45rem 0 0;\n  color: rgb(226 232 240 / 88%);\n  font-size: 0.9rem;\n  max-width: 36rem;\n}\n\n.fm-render {\n  display: flex;\n  flex-direction: column;\n}\n\n.fm-render-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1.05rem;\n  padding: 1.4rem 1.5rem 1.6rem;\n}\n\n.fm-r-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.fm-r-label {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--fm-ink);\n  margin: 0;\n}\n\n.fm-req {\n  color: #ef4444;\n  margin-left: 0.2rem;\n}\n\n.fm-r-help {\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--fm-muted);\n}\n\n.fm-r-error {\n  margin: 0;\n  font-size: 0.78rem;\n  color: #dc2626;\n  font-weight: 500;\n}\n\n.fm-r-field input:not([type='checkbox']):not([type='radio']),\n.fm-r-field textarea,\n.fm-r-field select,\n.fm-r-field .searchable-select-trigger {\n  width: 100%;\n  padding: 0.65rem 0.8rem;\n  border: 1px solid var(--fm-line-strong);\n  border-radius: 10px;\n  background: #fff;\n  font: inherit;\n  font-size: 0.9rem;\n  color: var(--fm-ink);\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.fm-r-field textarea {\n  resize: vertical;\n  min-height: 5.5rem;\n}\n\n.fm-r-field input::placeholder,\n.fm-r-field textarea::placeholder {\n  color: #a0aabb;\n}\n\n.fm-r-field input:focus,\n.fm-r-field textarea:focus,\n.fm-r-field select:focus {\n  border-color: var(--fm-blue);\n  box-shadow: 0 0 0 3px rgb(20 99 255 / 12%);\n}\n\n.fm-r-field.has-error input,\n.fm-r-field.has-error textarea,\n.fm-r-field.has-error select,\n.fm-r-field.has-error .fm-drop {\n  border-color: #f87171;\n}\n\n.fm-r-heading h3 {\n  margin: 0.35rem 0 0;\n  font-size: 1.08rem;\n  font-weight: 700;\n}\n\n.fm-r-heading p {\n  margin: 0.2rem 0 0;\n  color: var(--fm-muted);\n  font-size: 0.85rem;\n}\n\n.fm-r-divider {\n  border: 0;\n  border-top: 1px solid var(--fm-line);\n  margin: 0.35rem 0;\n  opacity: 1;\n}\n\n.fm-r-paragraph {\n  margin: 0;\n  color: #475569;\n  font-size: 0.9rem;\n  white-space: pre-line;\n}\n\n.fm-choices {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.fm-choice {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 10px;\n  font-size: 0.88rem;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.fm-choice:hover {\n  border-color: #c9d6ee;\n}\n\n.fm-choice.is-on {\n  border-color: var(--fm-blue);\n  background: var(--fm-blue-soft);\n}\n\n.fm-choice input {\n  accent-color: var(--fm-blue);\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n}\n\n.fm-drop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 1.35rem 1rem;\n  border: 1.5px dashed #cdd6e5;\n  border-radius: 12px;\n  background: #fbfcfe;\n  color: #64748b;\n  text-align: center;\n  font-size: 0.86rem;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.fm-drop svg {\n  color: #64748b;\n}\n\n.fm-drop:hover,\n.fm-drop.is-over {\n  border-color: var(--fm-blue);\n  background: var(--fm-blue-soft);\n}\n\n.fm-drop.is-disabled {\n  cursor: default;\n}\n\n.fm-drop small {\n  font-size: 0.74rem;\n  color: #94a3b8;\n}\n\n.fm-link {\n  color: var(--fm-blue);\n  font-weight: 600;\n}\n\n.fm-file-list {\n  list-style: none;\n  margin: 0.5rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.fm-file-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.4rem 0.4rem 0.65rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 9px;\n  font-size: 0.84rem;\n}\n\n.fm-file-list li span {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fm-file-list li small {\n  color: var(--fm-muted);\n}\n\n.fm-submit {\n  align-self: flex-start;\n  padding: 0.7rem 1.6rem;\n  font-size: 0.92rem;\n}\n\n.fm-form-error {\n  margin: 0;\n  color: #dc2626;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.fm-hp {\n  position: absolute !important;\n  left: -9999px !important;\n  width: 1px !important;\n  height: 1px !important;\n  opacity: 0 !important;\n}\n\n.fm-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n}\n\n.fm-success h3 {\n  margin: 0.4rem 0 0;\n  font-size: 1.2rem;\n}\n\n.fm-success p {\n  margin: 0;\n  color: #475569;\n  max-width: 28rem;\n}\n\n.fm-success-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  background: #e7f8ef;\n  color: #16a34a;\n  flex: 0 0 auto;\n}\n\n.fm-preview-frame {\n  border: 1px solid var(--fm-line);\n  border-radius: var(--fm-radius);\n  overflow: hidden;\n  max-width: 44rem;\n  margin: 0 auto;\n}\n\n/* ---------- Settings tab ---------- */\n\n.fm-settings {\n  display: grid;\n  grid-template-columns: 14rem minmax(0, 1fr) 17.5rem;\n  gap: 1rem;\n  align-items: start;\n}\n\n.fm-subnav {\n  padding: 0.55rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  position: sticky;\n  top: 1rem;\n}\n\n.fm-subnav-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.6rem 0.7rem;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  font: inherit;\n  font-size: 0.86rem;\n  font-weight: 500;\n  color: #334155;\n  text-align: left;\n  cursor: pointer;\n}\n\n.fm-subnav-item svg {\n  color: #64748b;\n}\n\n.fm-subnav-item:hover {\n  background: #f5f7fb;\n}\n\n.fm-subnav-item.is-on {\n  background: var(--fm-blue-soft);\n  color: var(--fm-blue);\n  font-weight: 600;\n}\n\n.fm-subnav-item.is-on svg {\n  color: var(--fm-blue);\n}\n\n.fm-subnav-item.is-on::before {\n  content: '';\n  position: absolute;\n  left: -0.55rem;\n  top: 0.45rem;\n  bottom: 0.45rem;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: var(--fm-blue);\n}\n\n.fm-settings-main {\n  padding: 1.25rem 1.35rem 1.4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.95rem;\n}\n\n.fm-section-head h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.fm-section-head p {\n  margin: 0.2rem 0 0;\n  color: var(--fm-muted);\n  font-size: 0.82rem;\n}\n\n.fm-subsection {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  padding-top: 0.95rem;\n  border-top: 1px solid var(--fm-line);\n}\n\n.fm-subsection h4 {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.fm-vars {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  align-items: center;\n  font-size: 0.76rem;\n  color: var(--fm-muted);\n}\n\n.fm-vars code {\n  padding: 0.12rem 0.38rem;\n  border-radius: 6px;\n  background: #f1f4f9;\n  color: #334155;\n  font-size: 0.72rem;\n}\n\n.fm-form-type {\n  padding: 1.1rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  position: sticky;\n  top: 1rem;\n}\n\n.fm-form-type > p {\n  margin: -0.5rem 0 0;\n  color: var(--fm-muted);\n  font-size: 0.8rem;\n}\n\n.fm-radio-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.fm-radio-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.7rem 0.75rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 11px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.fm-radio-card:hover {\n  border-color: #c9d6ee;\n}\n\n.fm-radio-card.is-on {\n  border-color: var(--fm-blue);\n  background: var(--fm-blue-soft);\n}\n\n.fm-radio-card input {\n  margin-top: 0.2rem;\n  width: 1rem;\n  height: 1rem;\n  accent-color: var(--fm-blue);\n  flex: 0 0 auto;\n}\n\n.fm-radio-card strong {\n  display: block;\n  font-size: 0.87rem;\n  font-weight: 600;\n}\n\n.fm-radio-card small {\n  display: block;\n  color: var(--fm-muted);\n  font-size: 0.76rem;\n  line-height: 1.4;\n}\n\n/* ---------- Automations ---------- */\n\n.fm-automations {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 18rem;\n  gap: 1rem;\n  align-items: start;\n}\n\n.fm-auto-main {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.fm-auto-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.fm-auto-head h3 {\n  margin: 0;\n  font-size: 1.05rem;\n}\n\n.fm-auto-head p {\n  margin: 0.2rem 0 0;\n  color: var(--fm-muted);\n  font-size: 0.84rem;\n}\n\n.fm-rule {\n  padding: 1rem 1.1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.fm-rule.is-off {\n  opacity: 0.65;\n}\n\n.fm-rule-head {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.fm-rule-head .fm-toggle {\n  padding: 0;\n  gap: 0.5rem;\n}\n\n.fm-rule-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 9px;\n  background: #fff3df;\n  color: #ea8a0c;\n  flex: 0 0 auto;\n}\n\n.fm-rule-name {\n  flex: 1;\n  font-weight: 600 !important;\n  border-color: transparent !important;\n  padding-left: 0.4rem !important;\n}\n\n.fm-rule-name:hover {\n  border-color: var(--fm-line-strong) !important;\n}\n\n.fm-rule-flow {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  gap: 0.6rem;\n  align-items: end;\n}\n\n.fm-rule-arrow {\n  padding-bottom: 0.55rem;\n  color: #94a3b8;\n}\n\n.fm-rule-config {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.85rem;\n  background: var(--fm-bg-soft);\n  border-radius: 11px;\n}\n\n.fm-rule-config:empty {\n  display: none;\n}\n\n.fm-auto-builtins {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.fm-auto-builtins ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  font-size: 0.83rem;\n}\n\n.fm-auto-builtins li {\n  display: flex;\n  gap: 0.45rem;\n  align-items: flex-start;\n}\n\n.fm-auto-builtins li svg {\n  color: #16a34a;\n  flex: 0 0 auto;\n  margin-top: 0.15rem;\n}\n\n.fm-auto-builtins .fm-btn {\n  align-self: flex-start;\n}\n\n/* ---------- Submissions ---------- */\n\n.fm-subs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.fm-bulkbar {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  padding: 0.55rem 0.8rem;\n  border-radius: 11px;\n  background: var(--fm-blue-soft);\n  border: 1px solid #cfdcfb;\n  font-size: 0.86rem;\n}\n\n.fm-bulkbar strong {\n  margin-right: 0.35rem;\n  color: var(--fm-blue);\n}\n\n.fm-person {\n  display: flex;\n  flex-direction: column;\n}\n\n.fm-person strong {\n  font-weight: 600;\n}\n\n.fm-person small,\n.fm-when small {\n  color: var(--fm-muted);\n  font-size: 0.76rem;\n}\n\n.fm-when {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n}\n\n.fm-status-stack {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-wrap: wrap;\n}\n\n.fm-sub-status {\n  display: inline-flex;\n  padding: 0.2rem 0.6rem;\n  border-radius: 7px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.fm-sub-status--new {\n  background: #e9f0ff;\n  color: #2459d9;\n}\n\n.fm-sub-status--reviewed {\n  background: #e7f8ef;\n  color: #15803d;\n}\n\n.fm-late {\n  display: inline-flex;\n  padding: 0.2rem 0.55rem;\n  border-radius: 7px;\n  background: #fdeaea;\n  color: #dc2626;\n  font-size: 0.74rem;\n  font-weight: 600;\n}\n\n.fm-ontime {\n  font-size: 0.78rem;\n  color: #15803d;\n  font-weight: 500;\n}\n\n.fm-meta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  padding: 0.15rem 0.4rem;\n  border-radius: 6px;\n  background: #f1f4f9;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.fm-drawer-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  background: rgb(15 23 42 / 35%);\n  display: flex;\n  justify-content: flex-end;\n  animation: fm-fade 0.15s ease;\n}\n\n.fm-drawer {\n  --fm-blue: #1463ff;\n  --fm-blue-soft: #eef4ff;\n  --fm-line: #e6eaf2;\n  --fm-line-strong: #d7deea;\n  --fm-muted: #64748b;\n  --fm-ink: #0f172a;\n  --fm-bg-soft: #f7f9fc;\n  width: min(38rem, 100%);\n  height: 100%;\n  background: #fff;\n  box-shadow: -12px 0 40px rgb(15 23 42 / 18%);\n  display: flex;\n  flex-direction: column;\n  animation: fm-slide 0.2s ease;\n}\n\n@keyframes fm-fade {\n  from {\n    opacity: 0;\n  }\n}\n\n@keyframes fm-slide {\n  from {\n    transform: translateX(2rem);\n    opacity: 0;\n  }\n}\n\n.fm-drawer-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.2rem 1.4rem 0.9rem;\n  border-bottom: 1px solid var(--fm-line);\n}\n\n.fm-drawer-head h2 {\n  margin: 0.15rem 0 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.fm-drawer-head p {\n  margin: 0.2rem 0 0;\n  color: var(--fm-muted);\n  font-size: 0.84rem;\n}\n\n.fm-drawer-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  padding: 0.8rem 1.4rem;\n  background: var(--fm-bg-soft);\n  border-bottom: 1px solid var(--fm-line);\n}\n\n.fm-drawer-status-actions {\n  margin-left: auto;\n}\n\n.fm-drawer-reviewed {\n  padding: 0.5rem 1.4rem 0;\n}\n\n.fm-drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.1rem 1.4rem 1.4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.3rem;\n}\n\n.fm-answers {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  margin: 0;\n}\n\n.fm-answers-heading {\n  margin: 0.9rem 0 0.3rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--fm-muted);\n}\n\n.fm-answers-heading:first-child {\n  margin-top: 0;\n}\n\n.fm-answer {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #eef1f6;\n}\n\n.fm-answer dt {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 0.25rem;\n}\n\n.fm-answer dd {\n  margin: 0;\n  font-size: 0.93rem;\n  color: var(--fm-ink);\n}\n\n.fm-answer-text {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.fm-empty-answer {\n  color: #a0aabb;\n  font-style: italic;\n}\n\n.fm-answer-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.fm-answer-tags span {\n  padding: 0.18rem 0.55rem;\n  border-radius: 7px;\n  background: var(--fm-blue-soft);\n  color: var(--fm-blue);\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.fm-answer-files {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.fm-answer-files li {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.5rem 0.55rem 0.5rem 0.7rem;\n  border: 1px solid var(--fm-line);\n  border-radius: 10px;\n}\n\n.fm-answer-files li > span {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  font-size: 0.86rem;\n  word-break: break-all;\n}\n\n.fm-answer-files small {\n  color: var(--fm-muted);\n  font-size: 0.74rem;\n}\n\n.fm-notes,\n.fm-log {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.fm-notes h4,\n.fm-log h4 {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.fm-notes textarea {\n  width: 100%;\n  padding: 0.65rem 0.8rem;\n  border: 1px solid #f1d58a;\n  border-radius: 10px;\n  background: #fffdf3;\n  font: inherit;\n  font-size: 0.88rem;\n  resize: vertical;\n  outline: none;\n}\n\n.fm-notes textarea:focus {\n  border-color: #eab308;\n  box-shadow: 0 0 0 3px rgb(234 179 8 / 15%);\n}\n\n.fm-notes-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--fm-muted);\n}\n\n.fm-log ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n}\n\n.fm-log li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  color: #334155;\n}\n\n.fm-log li > span:nth-child(2) {\n  flex: 1;\n}\n\n.fm-log li strong {\n  text-transform: capitalize;\n}\n\n.fm-log li small {\n  color: var(--fm-muted);\n}\n\n.fm-log-dot {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  margin-top: 0.35rem;\n  background: #22c55e;\n  flex: 0 0 auto;\n}\n\n.fm-log li.is-fail .fm-log-dot {\n  background: #ef4444;\n}\n\n.fm-drawer-meta {\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));\n  gap: 0.75rem;\n  padding: 0.9rem;\n  border-radius: 11px;\n  background: var(--fm-bg-soft);\n}\n\n.fm-drawer-meta dt {\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--fm-muted);\n}\n\n.fm-drawer-meta dd {\n  margin: 0.15rem 0 0;\n  font-size: 0.85rem;\n  word-break: break-all;\n}\n\n.fm-drawer-foot {\n  padding: 0.8rem 1.4rem;\n  border-top: 1px solid var(--fm-line);\n  display: flex;\n  justify-content: flex-start;\n}\n\n/* ---------- Public page ---------- */\n\n.fm-public {\n  min-height: 100vh;\n  padding: 2.5rem 1rem 3rem;\n  background:\n    radial-gradient(circle at 0% 0%, rgb(20 99 255 / 8%), transparent 40%),\n    radial-gradient(circle at 100% 100%, rgb(109 63 216 / 8%), transparent 40%),\n    #f4f6fb;\n  color: var(--fm-ink);\n}\n\n.fm-public.is-embed {\n  min-height: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.fm-public-inner {\n  max-width: 44rem;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fm-public.is-embed .fm-public-inner {\n  max-width: none;\n}\n\n.fm-public-org {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  font-weight: 700;\n  font-size: 1rem;\n  color: #334155;\n}\n\n.fm-public-org img {\n  max-height: 2.2rem;\n  max-width: 10rem;\n  object-fit: contain;\n}\n\n.fm-public-card {\n  overflow: hidden;\n}\n\n.fm-public.is-embed .fm-public-card {\n  box-shadow: none;\n}\n\n.fm-public-msg {\n  padding: 2.5rem 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--fm-muted);\n}\n\n/* ---------- Client portal ---------- */\n\n.fm-portal {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  color: var(--fm-ink);\n}\n\n.fm-portal-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.fm-portal-section h2 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.fm-portal-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.fm-portal-card {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  padding: 0.95rem 1.1rem;\n  color: inherit;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.fm-portal-card:hover {\n  text-decoration: none;\n  border-color: #b8cdfb;\n  box-shadow: 0 6px 18px rgb(15 23 42 / 8%);\n}\n\n.fm-portal-card-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.fm-portal-card-text strong {\n  font-weight: 600;\n}\n\n.fm-portal-card-text small {\n  color: var(--fm-muted);\n  font-size: 0.8rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fm-portal-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  font-size: 0.76rem;\n  color: var(--fm-muted);\n}\n\n.fm-portal-card-meta .is-late {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.fm-portal-card-cta {\n  color: var(--fm-blue);\n  font-weight: 600;\n  font-size: 0.86rem;\n}\n\n.fm-portal-fill .fm-public-card,\n.fm-portal-done {\n  max-width: 46rem;\n}\n\n.fm-portal-done {\n  padding: 1.3rem 1.4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fm-portal-done-head {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  flex-wrap: wrap;\n}\n\n.fm-portal-done-head > div {\n  flex: 1;\n}\n\n.fm-portal-done-head h2 {\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n.fm-portal-done-head p {\n  margin: 0.15rem 0 0;\n  color: var(--fm-muted);\n  font-size: 0.85rem;\n}\n\n.fm-due-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n  width: fit-content;\n  padding: 0.3rem 0.65rem;\n  border-radius: 8px;\n  background: #f1f4f9;\n  color: #334155;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.fm-due-note.is-late {\n  background: #fdeaea;\n  color: #dc2626;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 1280px) {\n  .fm-build {\n    grid-template-columns: 12.5rem minmax(0, 1fr) 16.5rem;\n  }\n\n  .fm-settings {\n    grid-template-columns: 12.5rem minmax(0, 1fr);\n  }\n\n  .fm-form-type {\n    grid-column: 1 / -1;\n    position: static;\n  }\n\n  .fm-radio-cards {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1100px) {\n  .fm-stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .fm-build {\n    grid-template-columns: 1fr;\n  }\n\n  .fm-palette,\n  .fm-side {\n    position: static;\n  }\n\n  .fm-palette ul {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(9rem, 1fr));\n  }\n\n  .fm-automations {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 760px) {\n  .fm-page-head,\n  .fm-editor-head {\n    flex-direction: column;\n  }\n\n  .fm-editor-actions {\n    justify-content: flex-start;\n  }\n\n  .fm-stats,\n  .fm-grid-2,\n  .fm-grid-3,\n  .fm-settings,\n  .fm-radio-cards,\n  .fm-type-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .fm-subnav {\n    position: static;\n    flex-direction: row;\n    overflow-x: auto;\n  }\n\n  .fm-subnav-item.is-on::before {\n    display: none;\n  }\n\n  .fm-table-card {\n    overflow-x: auto;\n  }\n\n  .fm-search {\n    min-width: 0;\n    flex: 1;\n  }\n\n  .fm-rule-flow {\n    grid-template-columns: 1fr;\n  }\n\n  .fm-rule-arrow {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
